import { bool, string, node, func, object } from "prop-types";
import { isMobile } from "react-device-detect";
import { ScrollButtonContainer, useEstimateEditorSettings, useTableOverflowChecker } from "@tools";
import { Grid, TableContainer as MuiTableContainer } from "@material-ui/core";
import useStyle from "./TableContainer.style";
import classnames from "classnames";

export const TableContainer = ({
  tableHeaderRef,
  tableContainerIdentifier,
  children,
  onResize: resizeHandler,
  onScroll: scrollHandler,
  className,
  useAltBackground,
  useExpandCell,
}) => {
  const { isPdfPrinterView } = useEstimateEditorSettings();
  
  const {
    ref,
    onScroll,
    containerWidth,
    isTableContentOverflowing,
    scrollButtonProps
  } = useTableOverflowChecker(tableHeaderRef, resizeHandler, scrollHandler);
  
  const classes = useStyle({ containerWidth });
  
  return (
    <Grid item container className="relative">
      {
        !isPdfPrinterView && isTableContentOverflowing && !isMobile &&
        <ScrollButtonContainer {...scrollButtonProps} />
      }
      <MuiTableContainer
        ref={ref}
        id={tableContainerIdentifier}
        onScroll={onScroll}
        className={classnames(
          "tableContainer",
          "overflow-y-hidden",
          classes.root,
          isTableContentOverflowing && classes.overflows,
          useAltBackground && classes.altBackground,
          useExpandCell && classes.useExpandCell,
          className,
        )}
      >
        <Grid
          container
          // role="rowgroup"
          direction="column"
        >
          { children }
        </Grid>
      </MuiTableContainer>
    </Grid>
  )
}

TableContainer.propTypes = {
  tableHeaderRef: object,
  tableContainerIdentifier: string.isRequired,
  children: node.isRequired,
  actions: node,
  useExpandCell: bool,
  useAltBackground: bool,
  onResize: func,
  onScroll: func,
  className: string,
}